import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link, Button, TextField, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import axios from 'axios'; // If you're using axios
import { useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import SEO from '../seo/SEO';

function RamanathaswamyTemple({ onSave }) {

  const [templeData, setTempleData] = useState(null);
  const [weather, setWeather] = useState([]);
  




  const carouselItems = [
    {
      title: "Helicopter Services",
      image: "../assets/service-slider/amarnath-helicopter.svg",
      content: [
        {
          title: ["Baltal-Panjtarni: ₹3000–₹5000/person.",<br />,"Pahalgam-Panjtarni: ₹2000–₹4000/person."],
          prices: []
        }
      ]
    },
    {
      title: "Ponies/Palkis",
      image: "../assets/service-slider/amarnath-palki.svg",
      content: [
        "₹1000–₹2000/person (one way).",
      ]
    },

    {
      title: "Ropeway (Upcoming)",
      image: "../assets/service-slider/amarnath-ropeway.svg",
      content: [
        "9 km from Baltal to shrine.",
      ]
    },
  
  ];

  const weatherImg = [
    {
      image: "../assets/march-june.svg",
    },
    {
      image: "../assets/july-sept.svg",
    },
    {
      image: "../assets/oct-nov.svg",
    },
    {
      image: "../assets/dec-feb.svg",
    },
  ];
  const initialDescription = 'Demo text goes here.';
  const [description, setDescription] = useState(initialDescription);
  const [isEditing, setIsEditing] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
    if (onSave) {
      onSave(description); // Optionally update to API or parent state
    }
  };

  useEffect(() => {
    if (templeData?.sections?.[0]?.description) {
      setDescription(templeData.sections[0].description);
    }
  }, [templeData]);

  const mergedWeather = weather.map((item, index) => ({
    ...item,
    image: weatherImg[index]?.image || "/assets/default-placeholder.svg",
  }));

  const [openModal, setOpenModal] = useState(false);
  const [modalContent, setModalContent] = useState('');

  const getTruncatedText = (text, wordLimit = 24) => {
    const words = text.split(' ');
    if (words.length <= wordLimit) return text;
    return words.slice(0, wordLimit).join(' ') + '...';
  };

  const handleReadMore = (fullText) => {
    setModalContent(fullText);
    setOpenModal(true);
  };
  return (
    <>
      <SEO pageKey="ramanathaswamy" />
      <Box className="innerbanner" >
        <img src="../assets/banner/ramanathaswamy-image.svg" alt="" />
        <Box className="innerContent">
          <h1>Ramanathaswamy Temple</h1>
        </Box>
      </Box>
      <Box className="templeDetailBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" >
            <Grid size={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }} >
              <Box
                className="detailBoxContent"
                sx={{

                  position: 'relative',
                }}
              >
                <p className="mb-1">Ramanathaswamy Temple in Rameshwaram, Tamil Nadu, is one of India’s most sacred Shiva temples, linked to Lord Rama from the Ramayana. Legend says Rama worshipped a Shiva lingam here for forgiveness after defeating Ravana—one lingam made by Sita from sand, and another brought by Hanuman from the Himalayas. Devotees purify themselves in the 22 holy wells (theerthams) before darshan. The temple is famed for its stunning Dravidian architecture, including the world’s longest corridor with over 1,200 carved pillars. With its serene vibes and spiritual energy, a visit here offers peace, blessings, and a deep sense of devotion.</p>


              </Box>
            </Grid>
            <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }} >
              <Box className="detailBoxImg">
                <img src="../assets/rameshwar-about.svg" alt="" className='img-fluid' />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <section>
        <Box className="tempratureBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="center" justifyContent="center">
              <Grid size={12}>
                <Box className="templeInnerHeading">
                  <h2>Monthly Temperature Guide</h2>
                </Box>
              </Grid>

              <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox">
                  <img src="../assets/march-june.svg" alt="" className="w-100" />
                  <h3>
                     Summer
                    <br />
                    <span>30°C – 40°C</span>
                  </h3>
                </Box>
              </Grid>

                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 6, xs: 6 }}>
                <Box className="tempratureContentBox">
                  <img src="../assets/dec-feb.svg" alt="" className="w-100" />
                  <h3>
                    Winter
                    <br />
                    <span>31°C to 24°C</span>
                  </h3>
                </Box>
              </Grid>
            
            

              

            </Grid>
          </Container>
        </Box>
      </section>
      <section>
        <Box className="tampleTimingBox">
          <Container maxWidth="md">
            <Grid container spacing={2} alignItems="stretch">
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingImg">
                  <img src="../assets/rameshwaram-timing.svg" className='img-fluid' alt="" />
                </Box>
              </Grid>
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
                <Box className="tampleTimingContent grayBox p-lg-4">
                  <Box className="templeInnerHeading">
                    <h3>Temple Timings</h3>
                  </Box>
                  <ul>
                    <li>
                      Morning
                      <span>4:00 AM – 1:00 PM</span>
                    </li>

                    <li>
                      Evening
                      <span>3:00 PM – 8:30 PM</span>
                    </li>
                  </ul>


                  <Box className="templeInnerHeading mt-4">
                    <h3>Arti Timings</h3>
                  </Box>
                  <ul>
                    <li>
                      Multiple aartis from 
                      <span>5:00 AM to 8:00 PM</span>
                    </li>

                   
                  </ul>

                 
                  
                </Box>
              </Grid>
            </Grid>
            
           
          </Container>
        </Box>
      </section>
  
         <section className="lightGrayBox">
                <Container maxWidth="md">
              <Grid container spacing={2} alignItems="center" className="mt-4" justifyContent="center">
                <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                  <Box className="templeInnerHeading">
                    <h2>Plan Your Route</h2>
                  </Box>
                </Grid>


                
                  <Grid size={{ xl: 12, lg: 12, md: 12, sm: 6, xs: 12 }} >
                    <Box className="routeBox">
                      


                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/train.svg" alt="" className='img-fluid' />
                          <h3>Train</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p><span>Rameswaram has a railway station</span></p>
                          <p>Pickup/drop to temple: ₹200–₹300 (Auto/Taxi)</p>
                        </Box>
                      </Box>

                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/bus.svg" alt="" className='img-fluid' />
                          <h3>Bus</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p className='mb-0'> <span>Rameswaram has a major bus stand</span></p>
                          <p>Well-connected to Chennai, Kanyakumari, Madurai, Trichy via TNSTC buses</p>
                        </Box>
                      </Box>


                      <Box className="routeInnerBox">
                        <Box className="route1">
                          <img src="../assets/route-icon/texi.svg" alt="" className='img-fluid' />
                          <h3>Cab</h3>
                        </Box>
                        <Box className="route2">
                          <img src="../assets/route-icon/border.svg" alt="" className='img-fluid' />
                        </Box>
                        <Box className="route3">
                          <p>No Ola/Uber services available</p>
                        </Box>
                      </Box>
                      
                    </Box>
                  </Grid>
                


              </Grid>
              </Container>
            </section>

      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading">
                <h2>Visitor Statistics (Monthly Peak Footfall)</h2>
              </Box>


            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-4">
                <h3 className='heighLightText'>Peak and <span>Off-Season</span></h3>
                <p className='mb-1'>(visitors/month)</p>
                <h3>6.5 Lac</h3>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="peakMonthBox">
                  <Box>
                  <p>Daily</p>
                    <span>25k - 30k</span>
                  </Box>
                </Box>
              </Grid>

               
             

              <Grid size={{ xl: 2.4, lg: 2.4, md: 2.4, sm: 6, xs: 6 }} >
                <Box className="offPeakMonthBox">
                  <Box>
                  <p>Daily</p>
                    <span>15k - 20k</span>
                  </Box>
                </Box>
              </Grid>

              

              
             
            

        
          </Grid>
        </Container>
      </section>



      <Box className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Accommodation Information</h2>
              </Box>
            </Grid>
            
              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="/assets/accommodation-icon/icon7.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Dharamshalas/Rooms</h3>
                    <p className='mb-1'>Dormitories from ₹150</p>
                    <p className='mb-1'>AC rooms from ₹2000</p>
                    <p className='mb-1'>Advance booking highly recommended</p>
                  </Box>
                </Box>
              </Grid>

              <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                <Box className="accommodationBox">
                  <Box className="accommodationImg">
                    <img src="/assets/accommodation-icon/icon1.svg" className='img-fluid' alt="" />
                  </Box>
                  <Box className="accommodationContent">
                    <h3>Hotels</h3>
                    <p className='mb-1'>Available in Ramanathapuram, Pudukkottai (within 2 km)</p>
                    <p className='mb-1'>Tariffs start from ₹900 onwards</p>
                  </Box>
                </Box>
              </Grid>
              
            

          </Grid>
        </Container>
      </Box>

      <section>
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Here’s What You Should Know</h2>
              </Box>
            </Grid>
            
          

           
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>01</h2>
                      <h3>Dress Code</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li><span>Men:</span> Dhoti with shirt, pyjama, or pants with shirt</li>
                        <li><span>Women & Girls:</span> Sarees, churidars, or pavadai with half-sari</li>
                      </ul>
                      
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid> 


           


            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>02</h2>
                      <h3>Photography</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p>Prohibited in certain areas</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>


            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>03</h2>
                      <h3>Entry & Fees</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p>General Entry Fee: Not applicable</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>



          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>04</h2>
                      <h3>VIP Darshan / Special Pooja</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>₹300–₹500 depending on the day/festival/month</li>
                        <li>Special Darshan includes abhishekam pooja and bath in 24 sacred wells</li>
                        <li>Guides or priests recommended for assistance</li>
                      </ul>
                      
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid>



            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>05</h2>
                      <h3>Locker Facilities</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoList'>
                      <ul>
                        <li>Government-maintained locker rooms available</li>
                        <li>Several private locker facilities nearby</li>
                        <li>Paid Service</li>
                      </ul>
                      
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid> 

           


           
          </Grid>
        </Container>
      </section>



 {/* <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <div className='infoGuideBox'>
                <Grid container spacing={2} justifyContent="center" alignItems="center">
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }} >
                    <div className='infoHeading'>

                      <h2>02</h2>
                      <h3>Nearby Attractions</h3>

                    </div>
                  </Grid>

                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
                    <div className='infoList'>

                      <p className='mb-0'><span>Betaab Valley, Aru Valley</span> (near Pahalgam).</p>
                    </div>
                  </Grid>
                </Grid>
              </div>



            </Grid> */}
      <section className="lightGrayBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="center" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="templeInnerHeading mb-lg-4">
                <h2>Explore Nearby</h2>
              </Box>
            </Grid>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="explore-nearby">
                <Grid container spacing={2}>
                  {/* Left Column */}
                  <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }}>
                    <Box className="info-box">
                      <Typography className="title">Tourist Attractions</Typography>
                      <div className="block">
                        <p>Ramanathaswamy Temple</p>
                        <p>Agni Theertham</p>
                        <p>Dhanushkodi Beach</p>
                        <p>Pamban Bridge</p>
                        <p>Gandamadana Parvatham</p>
                        <p>Five-faced Hanuman Temple</p>
                      </div>
                     
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">Nearby ATMs</Typography>
                      <p>Indian Bank ATM</p>
                      <p>Central Bank of India ATM</p>
                    </Box>

                    <Box className="info-box mt-3">
                      <Typography className="title">Hospitals Nearby</Typography>
                      <p>Rameswaram Government Hospital – 2 km</p>
                      <p>Ramnad Government Hospital – 22 km</p>
                    </Box>

                    
                  </Grid>

                  {/* Right Column */}
                  <Grid size={{ xl: 5, lg: 5, md: 5, sm: 12, xs: 12 }}>
                    <Grid container spacing={2}>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Medical Stores</Typography>
                          <p>Rama Medicals (0.6 km)</p>
                          <p>Swamy Medical Store (0.4 km)</p>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Food</Typography>
                          <p>Rama Restaurant (0.4 km)</p>
                          <p>Swamy’s Kitchen (0.5 km)</p>
                          <div className='block'>
                          <span>Free Meals</span>
                          <p>Wholesome vegetarian meals served as prasad under temple's Annadanam scheme</p>
                          </div>
                        </Box>
                      </Grid>
                      <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                        <Box className="info-box">
                          <Typography className="title">Amenities</Typography>
                          <p><span>Drinking Water</span> Free</p>
                          <p><span>Restrooms</span> Not specified</p>
                          <p><span>Wheelchair Facility</span> Available</p>
                          <p><span>WiFi, Guide Audio, Online Booking, Museum</span> Not Available</p>
                        </Box>
                      </Grid>
                      
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Grid>

          </Grid>
        </Container>
      </section>


    

    


    </>
  );
}
export default RamanathaswamyTemple;